import React from "react";

const TranslationsData = () => (
    <>
        <div id="translations_list" class="publications">
            <h5><em>Last updated 04/04/2024</em></h5>
            <p>
                For additions, please contact <a href="mailto:mark.kamrath@ucf.edu">Mark L. Kamrath</a> or <a href="mailto:philipb@ku.edu">Philip Barnard</a>.
            </p>
            <h4><b>Chronological Listing by Language</b></h4>
            <h4><em>German</em></h4>
            <h4>1802</h4>
            <ul>
                <li class="hindent"><em>Ormond, oder der geheime Zeuge</em>. Aus dem Englischen des Godwin frei ubersetzt von Friedrich von Oertel.  Leipzig: Johann Gottlob Beygang, 1802.
                </li>
            </ul>
            <h4>1857</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntley oder der Nachtwandler</em>. Von Charles Brockden Brown. 3 volumes. Leipzig: Verlag von Christian Ernst Rollman, 1857.
                </li>
            </ul>
            <h4>1859</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia: Denkwürdigkeiten aus dem Jahre 1793</em>. Von Ch. Brockden Brown, Verfasser von Edgar Huntly, etc. Aus dem Englischen übersetzt. 4 volumes. Leipzig: Verlag von Christian Ernst Rollmann, 1859.
                </li>
            </ul>
            <h4>1977</h4>
            <ul>
                <li class="hindent"><em>Wieland, oder, die Verwandlung: Roman</em>. Ubersetzt von Friedrich Polakovics; mit einem Nachwort von Norbert Miller. München: Deutscher Taschenbuch Verlag, 1977.
                </li>
            </ul>
            <h4>1992</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia</em>.  Berlin: Henssel, 1992. [Modern re-edition of the 1859 Leipzig translation.]
                </li>
            </ul>
            <h4>1995</h4>
            <ul>
                <li class="hindent"><em>Wieland, oder, die Verwandlung: Roman</em>. Ubersetzt von Friedrich Polakovics ; mit einem Nachwort von Norbert Miller. Frankfurt am Main: Leipzig Insel-Verlag, 1995. [New edition of 1977 Polakovics-Miller translation.]
                </li>
            </ul>
            <h4>1999</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia: Roman</em>. Hrsg. und mit einem Nachw. vers. von Frederik Burwick. Die vorliegende Bearb. der anonymen Übers. aus dem Amerikan. von Jochen Reichel. Zürich: Diogenes Verlag, 1999. [Zürich edition, updating and correcting the 1859 translation.]
                </li>
            </ul>
            <h4>2004</h4>
            <ul>
                <li class="hindent"><em>Aus den Erinnerungen von Carwin dem Bauchredner: ein Fragment</em>. Aus dem Amerikan. übers. und hrsg. von Alexander Pechmann. Philadelphia: Achilla Presse, 2004.
                </li>
            </ul>
            <h4><em>French</em></h4>
            <h4>1808</h4>
            <ul>
                <li class="hindent"><em>La famille Wieland, ou les prodigies</em>, traduction libre d’un manuscript américain, par Pigault-Maubaillarcq, member correspondant de la Société Philotechnique. 4 volumes. Calais: Moreaux & Ce, 1808.
                </li>
            </ul>
            <h4>1841</h4>
            <ul>
                <li class="hindent"><em>Wieland, ou la voix mystérieuse</em>. Traduction faite sur la dernière édition de Londres par Auguste Callet et Javelin Pagnon. Avec une notice sur la vie de l’auteur. 2 volumes. Paris: W. Coquebert, 48 rue Jacob, 1841. [Vol. 2 of this edition contains <em>Wieland</em> up to page 294. Pages 295-340 add a tale, “La Maison du Diable” / “The Devil’s House,” with a notice that says that “The following tale appeared a few months ago, in an American newspaper [journal], under the name of Charles Brockden Brown....”]
                </li>
            </ul>
            <h4>1842</h4>
            <ul>
                <li class="hindent"><em>Wieland, ou la voix mystérieuse</em>. Traduction faite sur la dernière édition de Londres par Auguste Callet et Javelin Pagnon. Avec une notice sur la vie de l’auteur. 2 volumes. Bruxelles: Meline, Cans et C., 1842. [Belgian edition reproducing the 1841 Callet translation and introduction.]
                </li>
            </ul>
            <h4>1980</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntly, ou Les mémoires d’un somnambule</em>. Présentation de Françoise Charras, conclusion de Liliane Abensour. Paris: Jean-Michel Place, 1980.
                </li>
            </ul>
            <h4>1990</h4>
            <ul>
                <li class="hindent"><em>Wieland ou la voix mystérieuse. Suivi des Mémoires de Carwin le ventriloque</em>. Edition établie et présentée par Liliane Abensour et Françoise Charras. Paris: José Corti, 1990. [Modern edition of the 1841 Callet translation; the “Carwin” translation is not accounted for and is likely by Abensour and/or Charras.]
                </li>
            </ul>
            <h4>1999</h4>
            <ul>
                <li class="hindent">“L’Aliénation.” Traduit de l’américain par Liliane Abensour. In Marc Amfreville et Françoise Charras, eds. Profils Américains 11 (1999), special issue “Charles Brockden Brown,” 9-17. [Facing-page English-French translation of “Insanity: A Fragment.”]
                </li>
            </ul>
            <h4>2007</h4>
            <ul>
                <li class="hindent"><em>Ormond ou le témoin secret</em>. Edition établie et texte traduit par Marc Amfreville. Préface Nathalie Caron. Paris: Michel Houdiard, 2007.
                </li>
            </ul>
            <h4><em>Spanish</em></h4>
            <h4>1818</h4>
            <ul>
                <li class="hindent"><em>La familia de Vieland, ò los prodigios</em>. Puesta en espagñol por el Dr. D. Luis Monfort, Capellan Párroco del 2.o regimiento de Real Cuerpo de Artilleria, y Secretario de la Subdelagcion Castrense de Valencia. 4 volumes. Valencia: En la Imprenta de Estévan, 1818. 	[Follows the French 1808 Pigault-Maubaillarcq translation and extension.]
                </li>
            </ul>
            <h4>1830</h4>
            <ul>
                <li class="hindent"><em>Carvino, ò el hombre prodigioso</em>. Puesta en Español por el Doctor Luis Monfort. Valencia: Imprenta de Cabrerizo, 1830.
                    [Continues the extension of the 1818 Monfort translation with further adventures of Carwin.]
                </li>
            </ul>
            <h4>1992</h4>
            <ul>
                <li class="hindent"><em>Wieland, ò la Transformación</em>. Traduccción del Inglés de Juan Ignacio de la Iglesia. Madrid: Valdemar, 1992. “La presente edición de Wieland se complete con Las Memorias de Carwin, el biloquista.”
                </li>
            </ul>
            <h4>2024</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn (o Memorias del año 1793)</em>. Tradicción de Miguel Cisneros Perales. Sevilla: El Paseo, coll. Central, 2024).
                </li>
            </ul>
            <h4><em>Italian</em></h4>
            <h4>1962</h4>
            <ul>
                <li class="hindent"><em>Ormond, il Testimonio segreto</em>. A cura di C. Izzo, traduzione de M. Picci. Roma: Opera nuove, 1962.
                </li>
            </ul>
            <h4>1965</h4>
            <ul>
                <li class="hindent"><em>Wieland, ovvero La transformazione</em>. A cura di Marissa Bulgheroni, traduzione de Luciana Bulgheroni. Venezia: Neri Pozza Editore, 1965.
                </li>
            </ul>
            <h4>1985</h4>
            <ul>
                <li class="hindent"><em>Alcuin o il Paradiso delle Donne (1798-1815)</em>. Introduzione di Rosella Mamoli Zorzi. Traduzione, nota biografica et note di Paola Menegazzi. Napoli: Guida editori, 1985.
                </li>
            </ul>
            <h4>1988</h4>
            <ul>
                <li class="hindent"><em>Wieland o la transformazione</em>. A dura di Alessandro Ceni. Pordenone: Edizioni Studio Tesi, 1988. [A new edition of the 1965 Bulgheroni translation.]
                </li>
            </ul>
            <h4>1989</h4>
            <ul>
                <li class="hindent"><em>Wieland, ovvero La transformazione</em>. A cura di Marissa Bulgheroni, traduzione de Luciana Bulgheroni. Roma / Napoli: Edizioni Theoria, 1989.
                </li>
            </ul>
            <h4>2000</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntly ovvero Le memorie di un sonnambulo</em>. A cura di Michele Bottalico, traduzione di Angelinda Griseta. Firenze: Passigli Editore, 2000.
                </li>
            </ul>
            <h4><em>Japanese</em></h4>
            <h4>1976</h4>
            <ul>
                <li class="hindent">ウィーランド  [<em>Wieland</em>]. Translated by Masao Shimura. Tokyo: Kokusho Kankōkai, 1976.
                </li>
            </ul>
            <h4>1979</h4>
            <ul>
                <li class="hindent">エドガー・ハントリー /   [<em>Edgar Huntly</em>]. Translated by Toshio Yagi. Tokyo: Kokusho Kankōkai, 1979.
                </li>
            </ul>
            <h4><em>Chinese (Mandarin)</em></h4>
            <h4>2016</h4>
            <ul>
                <li class="hindent">威兰 /  [<em>Wieland</em>]. Translated by Qu Hong and Wang Danhong. Combined edition with a translation of Beckford’s <em>Vathek</em>. Hangzhous, Zhejiang Provice, China: Zhejiang Gongshang University press, 2016.
                </li>
            </ul>
            <h4><em>Korean</em></h4>
            <h4>2017</h4>
            <ul>
                <li class="hindent">윌랜드 : 탈바꿈: 미국 이야기 /. [<em>Wieland</em>]. Translated by Jaewang Hwang. Seoul: Hanguk Munhwasa, 2017.
                </li>
            </ul>
            <h4><b>Chronological Listing of All Translations</b></h4>
            <h4>1802</h4>
            <ul>
                <li class="hindent"><em>Ormond, oder der geheime Zeuge</em>. Aus dem Englischen des Godwin frei ubersetzt von Friedrich von Oertel.  Leipzig: Johann Gottlob Beygang, 1802.
                </li>
            </ul>
            <h4>1808</h4>
            <ul>
                <li class="hindent"><em>La famille Wieland, ou les prodigies</em>, traduction libre d’un manuscript américain, par Pigault-Maubaillarcq, member correspondant de la Société Philotechnique. 4 volumes. Calais: Moreaux & Ce, 1808.
                </li>
            </ul>
            <h4>1818</h4>
            <ul>
                <li class="hindent"><em>La familia de Vieland, ò los prodigios</em>. Puesta en espagñol por el Dr. D. Luis Monfort, Capellan Párroco del 2.o regimiento de Real Cuerpo de Artilleria, y Secretario de la Subdelagcion Castrense de Valencia. 4 volumes. Valencia: En la Imprenta de Estévan, 1818. 	[Follows the French 1808 Pigault-Maubaillarcq translation and extension.]
                </li>
            </ul>
            <h4>1830</h4>
            <ul>
                <li class="hindent"><em>Carvino, ò el hombre prodigioso</em>. Puesta en Español por el Doctor Luis Monfort. Valencia: Imprenta de Cabrerizo, 1830.
                    [Continues the extension of the 1818 Monfort translation with further adventures of Carwin.]
                </li>
            </ul>
            <h4>1841</h4>
            <ul>
                <li class="hindent"><em>Wieland, ou la voix mystérieuse</em>. Traduction faite sur la dernière édition de Londres par Auguste Callet et Javelin Pagnon. Avec une notice sur la vie de l’auteur. 2 volumes. Paris: W. Coquebert, 48 rue Jacob, 1841. [Vol. 2 of this edition contains <em>Wieland</em> up to page 294. Pages 295-340 add a tale, “La Maison du Diable” / “The Devil’s House,” with a notice that says that “The following tale appeared a few months ago, in an American newspaper [journal], under the name of Charles Brockden Brown....”]
                </li>
            </ul>
            <h4>1842</h4>
            <ul>
                <li class="hindent"><em>Wieland, ou la voix mystérieuse</em>. Traduction faite sur la dernière édition de Londres par Auguste Callet et Javelin Pagnon. Avec une notice sur la vie de l’auteur. 2 volumes. Bruxelles: Meline, Cans et C., 1842. [Belgian edition reproducing the 1841 Callet translation and introduction.]
                </li>
            </ul>
            <h4>1857</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntley oder der Nachtwandler</em>. Von Charles Brockden Brown. 3 volumes. Leipzig: Verlag von Christian Ernst Rollman, 1857.
                </li>
            </ul>
            <h4>1859</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia: Denkwürdigkeiten aus dem Jahre 1793</em>. Von Ch. Brockden Brown, Verfasser von Edgar Huntly, etc. Aus dem Englischen übersetzt. 4 volumes. Leipzig: Verlag von Christian Ernst Rollmann, 1859.
                </li>
            </ul>
            <h4>1962</h4>
            <ul>
                <li class="hindent"><em>Ormond, il Testimonio segreto</em>. A cura di C. Izzo, traduzione de M. Picci. Roma: Opera nuove, 1962.
                </li>
            </ul>
            <h4>1965</h4>
            <ul>
                <li class="hindent"><em>Wieland, ovvero La transformazione</em>. A cura di Marissa Bulgheroni, traduzione de Luciana Bulgheroni. Venezia: Neri Pozza Editore, 1965.
                </li>
            </ul>
            <h4>1976</h4>
            <ul>
                <li class="hindent">ウィーランド  [<em>Wieland</em>]. Translated by Masao Shimura. Tokyo: Kokusho Kankōkai, 1976.
                </li>
            </ul>
            <h4>1977</h4>
            <ul>
                <li class="hindent"><em>Wieland, oder, die Verwandlung: Roman</em>. Ubersetzt von Friedrich Polakovics; mit einem Nachwort von Norbert Miller. München: Deutscher Taschenbuch Verlag, 1977.
                </li>
            </ul>
            <h4>1979</h4>
            <ul>
                <li class="hindent">エドガー・ハントリー /   [<em>Edgar Huntly</em>]. Translated by Toshio Yagi. Tokyo: Kokusho Kankōkai, 1979.
                </li>
            </ul>
            <h4>1980</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntly, ou Les mémoires d’un somnambule</em>. Présentation de Françoise Charras, conclusion de Liliane Abensour. Paris: Jean-Michel Place, 1980.
                </li>
            </ul>
            <h4>1985</h4>
            <ul>
                <li class="hindent"><em>Alcuin o il Paradiso delle Donne (1798-1815)</em>. Introduzione di Rosella Mamoli Zorzi. Traduzione, nota biografica et note di Paola Menegazzi. Napoli: Guida editori, 1985.
                </li>
            </ul>
            <h4>1988</h4>
            <ul>
                <li class="hindent"><em>Wieland o la transformazione</em>. A dura di Alessandro Ceni. Pordenone: Edizioni Studio Tesi, 1988. [A new edition of the 1965 Bulgheroni translation.]
                </li>
            </ul>
            <h4>1989</h4>
            <ul>
                <li class="hindent"><em>Wieland, ovvero La transformazione</em>. A cura di Marissa Bulgheroni, traduzione de Luciana Bulgheroni. Roma / Napoli: Edizioni Theoria, 1989.
                </li>
            </ul>
            <h4>1990</h4>
            <ul>
                <li class="hindent"><em>Wieland ou la voix mystérieuse. Suivi des Mémoires de Carwin le ventriloque</em>. Edition établie et présentée par Liliane Abensour et Françoise Charras. Paris: José Corti, 1990. [Modern edition of the 1841 Callet translation; the “Carwin” translation is not accounted for and is likely by Abensour and/or Charras.]
                </li>
            </ul>
            <h4>1992</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia</em>.  Berlin: Henssel, 1992. [Modern re-edition of the 1859 Leipzig translation.]
                </li>
                <li class="hindent"><em>Wieland, ò la Transformación</em>. Traduccción del Inglés de Juan Ignacio de la Iglesia. Madrid: Valdemar, 1992. “La presente edición de Wieland se complete con Las Memorias de Carwin, el biloquista.”
                </li>
            </ul>
            <h4>1995</h4>
            <ul>
                <li class="hindent"><em>Wieland, oder, die Verwandlung: Roman</em>. Ubersetzt von Friedrich Polakovics ; mit einem Nachwort von Norbert Miller. Frankfurt am Main: Leipzig Insel-Verlag, 1995. [New edition of 1977 Polakovics-Miller translation.]
                </li>
            </ul>
            <h4>1999</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn, oder, Die Pest in Philadelphia: Roman</em>. Hrsg. und mit einem Nachw. vers. von Frederik Burwick. Die vorliegende Bearb. der anonymen Übers. aus dem Amerikan. von Jochen Reichel. Zürich: Diogenes Verlag, 1999. [Zürich edition, updating and correcting the 1859 translation.]
                </li>
                <li class="hindent">“L’Aliénation.” Traduit de l’américain par Liliane Abensour. In Marc Amfreville et Françoise Charras, eds. Profils Américains 11 (1999), special issue “Charles Brockden Brown,” 9-17. [Facing-page English-French translation of “Insanity: A Fragment.”]
                </li>
            </ul>
            <h4>2000</h4>
            <ul>
                <li class="hindent"><em>Edgar Huntly ovvero Le memorie di un sonnambulo</em>. A cura di Michele Bottalico, traduzione di Angelinda Griseta. Firenze: Passigli Editore, 2000.
                </li>
            </ul>
            <h4>2004</h4>
            <ul>
                <li class="hindent"><em>Aus den Erinnerungen von Carwin dem Bauchredner: ein Fragment</em>. Aus dem Amerikan. übers. und hrsg. von Alexander Pechmann. Philadelphia: Achilla Presse, 2004.
                </li>
            </ul>
            <h4>2007</h4>
            <ul>
                <li class="hindent"><em>Ormond ou le témoin secret</em>. Edition établie et texte traduit par Marc Amfreville. Préface Nathalie Caron. Paris: Michel Houdiard, 2007.
                </li>
            </ul>
            <h4>2016</h4>
            <ul>
                <li class="hindent">威兰 /  [<em>Wieland</em>]. Translated by Qu Hong and Wang Danhong. Combined edition with a translation of Beckford’s <em>Vathek</em>. Hangzhous, Zhejiang Provice, China: Zhejiang Gongshang University press, 2016.
                </li>
            </ul>
            <h4>2017</h4>
            <ul>
                <li class="hindent">윌랜드 : 탈바꿈: 미국 이야기 /. [<em>Wieland</em>]. Translated by Jaewang Hwang. Seoul: Hanguk Munhwasa, 2017.
                </li>
            </ul>
            <h4>2024</h4>
            <ul>
                <li class="hindent"><em>Arthur Mervyn (o Memorias del año 1793)</em>. Tradicción de Miguel Cisneros Perales. Sevilla: El Paseo, coll. Central, 2024).
                </li>
            </ul>
        </div>
    </>
)

export default TranslationsData;